import { createContext, useContext, useState, useCallback } from "react";

const ChatbotContext = createContext(null);

export const ChatbotProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openChatbot = useCallback(() => setOpen(true), []);
  const closeChatbot = useCallback(() => setOpen(false), []);
  return (
    <ChatbotContext.Provider value={{ open, setOpen, openChatbot, closeChatbot }}>
      {children}
    </ChatbotContext.Provider>
  );
};

export const useChatbot = () => {
  const ctx = useContext(ChatbotContext);
  if (!ctx) throw new Error("useChatbot must be used within ChatbotProvider");
  return ctx;
};
